const PLACE_TYPE_RU = {
    boatyard: "Верфь",
    port: "Порт",
    wastewater: "Сточные воды",
    dock: "Док",
    waterfall: "Водопад",
    lock_gate: "Шлюз",
    oxbow: "Старица",
    reservoir: "Водохранилище",
    milestone: "Гидроориентир",
    river: "Река",
    canal: "Канал",
    lake: "Озеро",
    yes: "Водоем",
    spring: "Родник",
    water: "Вода",
    drain: "Слив",
    stream: "Ручей",
    scrub: "Кустарник у воды",
    moat: "Ров",
    basin: "Бассейн",
    dam: "Плотина",
    wood: "Лесной водоем",
    wetland: "Болото",
    flowline: "Поток",
    pressurised: "Напорный водовод",
    pond: "Пруд",
    drystream: "Пересыхающий ручей",
    grassland: "Луг у воды",
    ditch: "Канава",
    weir: "Переливная плотина",
};

export function placeTypeRu(type) {
    if (!type) return "-";
    return PLACE_TYPE_RU[type] || type;
}
